var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinktree({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2137 7.27959L16.4512 4.11792L18.3303 5.9461L14.9344 9.02174H19.7113V11.5597H14.9117L18.3303 14.7142L16.4512 16.5066L11.8101 12.0759L7.16895 16.5066L5.28986 14.7214L8.70844 11.5668H3.90884V9.02174H8.6858L5.28986 5.9461L7.16895 4.11792L10.4064 7.27959V2.78442H13.2137V7.27959ZM10.4064 15.1945H13.2137V21.2168H10.4064V15.1945Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinktree);
export default __webpack_public_path__ + "static/media/linktree.2708d1ea97328d1aad4fb96ffb1062b8.svg";
export { ForwardRef as ReactComponent };